export const toggleFullScreen = async (): Promise<void> => {
  console.log("TOGGLE FS");
  if (document.fullscreenElement) {
    document.exitFullscreen();
  } else {
    document.documentElement.requestFullscreen({
      navigationUI: "hide",
    });
  }
};
